<template>
    <div class="container">
        <b-form-group :label="$t('bookings.driver')" label-for="driver-select">
            <b-form-select
                size="sm"
                v-model="selectedDriver"
                :options="userDriverOpts"
                :disabled="loading"
                @change="search"
            ></b-form-select>
        </b-form-group>
        <b-form-group :label="$t('bookings.transportUnit')"  v-if="localRidesSelected.length>0">
				<b-form-select
					size="sm"
					v-model="transportUnitId"
					:options="transportUnitsOpts"
					required
				/>
		</b-form-group>
        <b-form-group :label="$t('global.date')" label-for="driver-select">
           <b-form-datepicker
                :locale="$root.store.state.currentUser.lang"
                reset-button
                size="sm"
                v-model="date"
                @input="dateChanged"
                
            />
        </b-form-group>
        
        <div>
            <hr>
            <b-tabs content-class="mt-3" align="center">
                <b-tab  active>
                    <template #title>{{ $t("assignation.assigned") }} <b v-if="rides.rows.length>0">{{rides.rows.length}}</b> </template>
                    <b-alert variant="info" v-if="$root.isEmpty(selectedDriver)" show class="text-center">
                        {{ $t("assignation.selectDrivertoContinue")  }}
                    </b-alert> 
                    <b-alert variant="warning" v-if="!$root.isEmpty(selectedDriver) && !loading && $root.isEmpty(rides.rows)" show class="text-center">
                        {{ $t("assignation.noRides") }}
                    </b-alert>
                    <section v-if="!$root.isEmpty(selectedDriver)" class="mb-5"> 
                        <b-card v-for="(ride, index) in rides.rows" :key="index" class="mb-1 p-1 ride-list" :class="{ 'striped': index % 2 !== 0 }" >
                            <b-row>
                                <b-col>
                                    <p class="text-secondary">
                                        <b-badge  variant="default" v-if="ride.reservation.operatedBy === 'sc'"> <ScIcon /> {{$t('bookings.shuttleCentralService')}}</b-badge>
                                        <b-badge  variant="default" v-else><md-icon icon="home" /> <strong>{{$t('bookings.selfService')}}</strong></b-badge>
                                    </p>
                                </b-col>
                                <b-col>
                                    <p class="text-right mr-3 mb-2 text-primary"><md-icon :icon="tripIcon(ride)"/>
                                        <a href="#" @click="openReservation(ride)" class="text-primary">{{ ride.serviceNumber }}</a>
                                        | <b-badge :variant="getVariantBystatus(ride.status)">{{ $t("bookings.serviceStatusOpts."+ride.status) }}</b-badge>
                                    </p>
                                </b-col>
                            </b-row>
                            <p><b>{{ $t("bookings.clientName") }}:</b> {{ ride.reservation.client.firstName }}  {{ ride.reservation.client.lastName }}</p>
                            <p><b>{{ $t("bookings.pickupDatetime") }}:</b> {{ ride.pickupDatetime }}</p>
                            <p><b>{{ $t("bookings.pickup") }}:</b> {{ ride.pickup.name }}</p>
                            <p><b>{{ $t("bookings.dropoff") }}:</b> {{ ride.dropoff.name }}</p>
                        </b-card>
                    </section>
                </b-tab>
                <b-tab title="Rides selected" v-if="false"><p></p></b-tab>
                <b-tab :title="$t('assignation.summary')" @click="getResume">
                    <b-table striped hover :items="resume.rows" :fields="fields.resume">
                        <template #cell(driver)="data">
                            <span class="capitalize">{{ data.item.firstName }} {{ data.item.lastName }}</span>
                        </template>
                    </b-table>
                </b-tab>
            </b-tabs>
        </div>
       
        <b-overlay :show="loading" no-wrap></b-overlay>
        <div class="fixed-bottom mt-3" v-if="localRidesSelected.length>0" @click="assignRides">
            <b-button block variant="primary" >{{ $t('bookings.assign') }} <b>({{  localRidesSelected.length }})</b></b-button>
        </div>
        <Single
            ref="reservation-single-assignation"
            :model-id.sync="resMod.modelId"
            :show.sync="resMod.show"
            operated-by="supplier"
		/>
    </div>
  </template>
  
  <script>
import moment from 'moment';
import Single from './../reservations/Single.vue'
  export default {
    name: 'DriverAssignment',
    components: {Single},
    props: {
		ridesSelected: {
			type: Array,
			required: false
		}
	},
    data() {
        return {
            selectedDriver: null,
            transportUnitId:null,
            loading: false,
            rides:{rows:[]},
            resume:{rows:[]},
            date: moment().format("YYYY-MM-DD"),
            fields:{
                resume:[
                    { key: 'driver', label: this.$t('bookings.driver') },
                    { key: 'count', label: this.$t("bookings.assignedServices") },
                ]
            },
            resMod:{
                modelId:-1,
                show:false
            }
        };
    },
    computed:{
        localRidesSelected(){
            if(this.$root.isEmpty(this.ridesSelected)) return [];
            return this.ridesSelected;
        },
        userDriverOpts() {
			let aux = JSON.parse(JSON.stringify(this.$root.auxVars.userDriverOpts));
			aux.unshift({ value: null, text: "TBA" });
			return aux;
		},
        transportUnitsOpts() {
			let aux = JSON.parse(JSON.stringify(this.$root.auxVars.transportUnitsOpts));
			aux.unshift({ value: null, text: "TBA" });
			return aux;
		},
    },
    methods: {
        tripIcon(rideModel) {
			if (rideModel.pickup.isAirport) return "flight_land";
			//A2H
			else if (rideModel.dropoff.isAirport) return "flight_takeoff";
			//H2A
			else return "place"; //P2P
		},
        openReservation(rideModel){
            this.resMod.modelId = rideModel.reservationId;
            this.resMod.show    = true;
		},
        async dateChanged(){
            this.search();
            this.getResume();
        },
        async getRides(){
            try{
                let params={
                    filters:{
                        userDriverId:this.selectedDriver,
                        pickupStartDate:this.date,
                        pickupEndDate:this.date
                    },
                    limit:500,
                    offset:0,
                    sortBy:"pickupDatetime",
                    sortOrder:'ASC'
                }
                const response = await this.$root.api
                .get(`/transport-services`,{params:params})
                return response.data;
            }catch(error){
                console.error('Error fetching rides:', error);
                return []; // Return an empty array in case of error
            }
        },
        async search(){
            if(this.$root.isEmpty(this.selectedDriver)) return;
            this.loading = true;
            this.rides = await this.getRides();
            this.loading=false;
        },
        getVariantBystatus(status){
			try{
				let variant = this.$root.auxVars.transportServiceStatusOpts.find((el)=>{
					return el.value==status
				});
				if(variant) return variant.class;
			}catch(err){console.log(err)}
			return "info";
		},
        async assignRides(ev) {
			ev.preventDefault();
			this.loading = true;
			this.$root.api
            .put(`/transport-services-assigment`, {
                ids: this.localRidesSelected,
                driverId: this.selectedDriver,
                transportUnitId: this.transportUnitId
            })
            .then(() => {
                this.loading = false;
                this.$root.showAlert("Actualizacion exitosa");
                this.$emit("update:show", false);
                this.$emit("onUpdate");
                this.search();
            })
            .catch(err => {
                this.$root.handleRequestError(err);
                this.loading = false;
            });
		},
        getResume() {
            try{
                this.loading = true;
                let params={
                    filters:{
                        pickupStartDate:this.date,
                        pickupEndDate:this.date
                    },
                    limit:500,
                    offset:0,
                    sortBy:"pickupDatetime",
                    sortOrder:'ASC'
                }
                this.$root.api
                .get(`/operation/resume`,{params:params})
                .then((res) => {
                    this.resume= res.data;
                })
                .finally(()=>{
                    this.loading = false;
                })
            }catch(error){
                console.error('Error fetching rides:', error);
                return []; // Return an empty array in case of error
            }
		}
    },
    mounted(){
        this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: ["transportUnitsOpts", "userDriverOpts"]
		});
    }
  };
  </script>
<style scoped>
    .ride-list{
        padding: 10px;
        overflow-y: scroll;
        /*height: 600px;*/
        background: #f7f7f7;
        border-radius: 1rem;
    }
    .card-body{
        padding: 5px !important;
    }
    p{
        margin: 0.5px;
        font-size: smaller;
    }
    .card{
        border-radius: 1.5rem !important;
    }
    .striped{
        background-color: #f4f8fc;
    }
    >>>label{
        margin-bottom: unset !important;
    }
</style>
  